import Loadable from 'react-loadable'
import { AsyncComponentLoader } from './loaders'

export default function asyncComponent(opts) {
  return Loadable({
    loading: AsyncComponentLoader,
    delay: 300,
    timeout: 5000,
    ...opts,
  })
}
